import axios from "axios";
import { API_BASE } from "@/lib/api";

const accountApi = axios.create({ baseURL: API_BASE });

accountApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("pp_account_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default accountApi;
